<template>
    <div>
        <!--        @close="this.selectArr = [],this.selectItem = null"-->

        <el-dialog
            :visible.sync="centerDialogVisible"
            append-to-body
            center
            title="选择资源"
            width="30%"
            @close="datas = [],selectItem=null,resourceList=[]">
            <div v-loading="loading">
                <div v-if="datas.length > 0">
                    <el-select
                        v-model="selectItem"
                        placeholder="请选择"
                        style="width: 4rem;margin-bottom: 0.12rem"
                        @change="selectChange"
                    >
                        <el-option
                            v-for="item in datas"
                            :key="item.flag"
                            :label="'供应商于' + ' '  + (dateFormatHm(item.createTime)) + ' ' + '提供了如下资源:'"
                            :value="item.flag"
                        >
                            <!--                          <span style="margin-right: 0.12rem">{{ dateFormatHm(item.createTime) }}</span>-->
                            <span>供应商于 {{ dateFormatHm(item.createTime) }} 提供了如下资源:</span>
                            <!--                                <el-tag :type="item.flagType ? 'success' : ''">{{ item.flagType ? '批量确认' : '单项确认'}} </el-tag>-->
                        </el-option>
                    </el-select>
                    <div v-for="items in resourceList" :key="items.resourceId"
                         style="padding: 14px; box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;margin-bottom: 10px;">
                        <div style="display: flex;align-items: center">
                            <div
                                :style="{borderColor:selectArr.findIndex(n => n.resourceId === items.resourceId) !== -1 ? '#CB582E' : '#CCCCCC'}"
                                style="height: 0.25rem;width: 0.25rem;border-radius: 5px;border: 1px solid;display:flex;align-items: center;justify-content: center;cursor: pointer;"
                                @click="handlerSeeResClick(items)">
                                <i v-show="selectArr.findIndex(n => n.resourceId === items.resourceId) !== -1"
                                   class="el-icon-check"
                                   style="color: #CB582E;font-size: 16px"></i>
                            </div>
                            <h2 style="margin: 10px" @click="goToResourceDetail(items.resourceId)">{{
                                    items.resourceName
                                }}</h2>
                        </div>
                        <p v-for="item in items.orderListDetailResultList" :key="item.id" style="margin-left: 32px">
                                {{conversionDate(item.startTime) }} 至 {{addOneDay(item.endTime)}} 提供 <span style="font-weight: bold;color: #CB582E">{{item.number}}{{item.priceCompany}}</span> <span style="font-weight: bold">{{item.productName}}</span>
                        </p>
                    </div>
                </div>
                <el-empty v-else description="暂无资源~~~"></el-empty>
            </div>
            <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
  </span>
        </el-dialog>
        <resource-detail ref="resourceDetail"></resource-detail>
    </div>
</template>
<script>
import OrderApi from "@/components/Api/order";
import ResourceApi from "@/components/Api/resource";
import ResourceDetail from "@/views/plan/info/ResourceDetail.vue";
import {addOneDay, conversionDate, dateFormatHm} from "@/assets/utils/unit";

export default {
    components: {
        ResourceDetail
    },
    data() {
        return {
            needProduct:{},//需要的产品数据
            isSave:false,//是否可以保存
            centerDialogVisible: false,
            loading: false,
            flagType: null,//0单选，1多选
            selectArr: [],
            resourceList: [],
            selectItem: null,
            datas: {}
        }
    },
    methods: {
        addOneDay,
        conversionDate,
        dateFormatHm,
        selectChange(val) {
            let item = this.datas.find(n => n.flag === val)
            this.resourceList = item.queryCustomSelectResourceResults
            this.flagType = item.flagType
            this.selectArr = []
        },
        goToResourceDetail(resourceId) {
            new ResourceApi('resource').resourceDetail({rid: resourceId}).then(res => {
                if (res.status === 200) {
                    let arr = [0, 1, 2]
                    if (!arr.includes(res.data.state)) return
                    this.$refs.resourceDetail.init(res.data)
                }
            }).catch(err => {
                this.$message.error('服务器错误!')
            })
        },
        save() {
            let ids = []
            if (!this.selectArr.length) {
                this.$message.warning('请选择资源！')
                return
            }

            // 检查是否满足所有需求
            const neededProducts = this.calculateNeededProducts();
            const selectedProducts = this.calculateSelectedProductQuantities();
            
            // 检查是否所有需要的产品都已选择，且数量一致 (暂时先注释判断)
            // let allProductsSelected = true;
            // for (const key in neededProducts) {
            //     if (!selectedProducts[key] || selectedProducts[key] !== neededProducts[key]) {
            //         allProductsSelected = false;
            //         break;
            //     }
            // }
            //
            // if (!allProductsSelected) {
            //     this.$message.warning('所选资源不满足所有需求，请重新选择！');
            //     return;
            // }
            
            // 检查日期是否符合要求
            let allDatesMatched = true;
            // 收集所有选中资源的产品
            let allSelectedProducts = [];
            this.selectArr.forEach(item => {
                item.orderListDetailResultList.forEach(product => {
                    allSelectedProducts.push({
                        stockId: product.stockId,
                        number: product.number,
                        startTime: conversionDate(product.startTime),
                        endTime: addOneDay(product.endTime),
                        productName: product.productName,
                    });
                });
            });
            
            // 检查日期
            if (!this.checkDateRanges(allSelectedProducts)) {
                this.$message.warning('所选资源的日期不满足需求，请重新选择！');
                return;
            }
            
            // 所有条件都满足，可以保存
            this.selectArr.forEach(item => {
                ids = [...ids, ...item.purchaseOrderChildrenIds]
            })
            console.log(ids);
            
            new OrderApi("order")
                .platformConfirmsBudgetResources(ids)
                .then((res) => {
                    if (res.status === 200) {
                        this.$message({
                            type: "success",
                            message: "保存成功!",
                        });
                        this.$emit('updateList')
                        this.centerDialogVisible = false
                    } else {
                        this.$message.error(res.statusText)
                    }
                });
        },
        open(needProduct,orderChildrenId) {
            this.needProduct = needProduct
            this.selectArr = []
            this.centerDialogVisible = true
            this.getData(orderChildrenId)
        },
        //选择
        handlerSeeResClick(val) {
            // 检查是否已经选中
            const existIndex = this.selectArr.findIndex(n => n.resourceId === val.resourceId);
            if (existIndex === -1) {
                // 未选中，需要添加
                // 将资源的产品列表转换为标准格式
                let arr = val.orderListDetailResultList.map(item => {
                    return {
                        stockId: item.stockId,
                        number: item.number,
                        startTime: conversionDate(item.startTime),//开始时间
                        endTime: addOneDay(item.endTime),//结束时间
                        productName: item.productName,
                    }
                });

                let addType = -5
                if (val.orderListDetailResultList && val.orderListDetailResultList.length > 0) {
                    addType = val.orderListDetailResultList[0].addType || -5
                }
                
                // 计算新选中的产品会增加的数量
                let newProducts = this.calculateProductQuantities(val.orderListDetailResultList);
                
                // 计算需要的产品总数
                let neededProducts = this.calculateNeededProducts();
                
                // 检查是否符合需求
                let canAdd = true;
                
                if (this.flagType) {
                    // 多选模式：检查选中后是否超出需要的数量
                    // 计算当前已选中的产品数量
                    let currentSelectedProducts = this.calculateSelectedProductQuantities();
                    
                    // 检查选中后是否超出需要的数量
                    for (const key in newProducts) {
                        const totalAfterSelection = (currentSelectedProducts[key] || 0) + newProducts[key];
                        if (!neededProducts[key] || totalAfterSelection > neededProducts[key] && addType === 0) {
                            canAdd = false;
                            break;
                        }
                    }
                    // 检查日期是否在范围内
                    if (canAdd) {
                        // 使用checkDateRanges方法检查日期
                        canAdd = this.checkDateRanges(arr);
                        this.selectArr.push(val);
                    } else {
                        this.$message.warning('所选资源不符合需求或日期范围不匹配！');
                    }
                } else {
                    // 单选模式：检查选中的产品是否满足需求
                    // 检查选中的产品是否满足需求
                    for (const key in neededProducts) {
                        // 如果需要的产品在新选中的产品中不存在，或者数量不匹配
                        if (!newProducts[key] || newProducts[key] !== neededProducts[key] && addType === 0) {
                            canAdd = false;
                            break;
                        }
                    }
                    
                    // 检查日期是否在范围内
                    if (canAdd) {
                        canAdd = this.checkDateRanges(arr);
                    }
                    
                    // 如果可以添加，则添加到选中数组
                    if (canAdd) {
                        this.selectArr = [val];
                    } else {
                        this.$message.warning('所选资源不符合需求！');
                    }
                }

            } else {
                // 已选中，需要取消选中
                this.selectArr = this.selectArr.filter(n => n.resourceId !== val.resourceId);
            }
        },
        
        // 计算产品数量
        calculateProductQuantities(productList) {
            let products = {};
            productList.forEach(product => {
                const key = product.productName;
                if (!products[key]) {
                    products[key] = 0;
                }
                products[key] += product.number;
            });
            return products;
        },
        
        // 计算已选中的产品数量
        calculateSelectedProductQuantities() {
            let selectedProducts = {};
            this.selectArr.forEach(selectedItem => {
                selectedItem.orderListDetailResultList.forEach(product => {
                    const key = product.productName;
                    if (!selectedProducts[key]) {
                        selectedProducts[key] = 0;
                    }
                    selectedProducts[key] += product.number;
                });
            });
            return selectedProducts;
        },
        
        // 计算需要的产品总数
        calculateNeededProducts() {
            let neededProducts = {};
            for (const stockId in this.needProduct) {
                this.needProduct[stockId].forEach(product => {
                    const key = product.productName;
                    if (!neededProducts[key]) {
                        neededProducts[key] = 0;
                    }
                    neededProducts[key] += product.number;
                });
            }
            return neededProducts;
        },
        
        // 检查日期范围
        checkDateRanges(productArr) {
            for (const stockId in this.needProduct) {
                const neededProducts = this.needProduct[stockId];
                
                for (let i = 0; i < neededProducts.length; i++) {
                    const neededProduct = neededProducts[i];
                    let dateMatched = false;
                    
                    for (let j = 0; j < productArr.length; j++) {
                        const product = productArr[j];
                        if (product.productName === neededProduct.productName) {
                            const productStartDate = new Date(product.startTime); 
                            const productEndDate = new Date(product.endTime); 
                            const neededStartDate = new Date(neededProduct.startTime); 
                            const neededEndDate = new Date(neededProduct.endTime);
                            
                            // 需求的日期等于或在提供产品的日期范围区间内
                            if ((neededStartDate >= productStartDate && neededEndDate <= productEndDate) || 
                                (product.startTime === neededProduct.startTime && product.endTime === neededProduct.endTime)) {
                                dateMatched = true;
                                break;
                            }
                        }
                    }
                    
                    if (!dateMatched) {
                        return false;
                    }
                }
            }
            return true;
        },
        getData(orderChildrenId) {
            this.loading = true
            new OrderApi('order').queryCustomSelectResource(orderChildrenId).then(res => {
                if (res.status === 200) {
                    this.datas = res.data
                    if (this.datas.length > 0) {
                        this.selectItem = this.datas[0].flag
                        this.resourceList = this.datas[0].queryCustomSelectResourceResults
                        this.flagType = this.datas[0].flagType
                    }
                    this.loading = false
                } else {
                    this.loading = false
                    this.$message.error(res.statusText)
                }
            })
        }
    }
}

</script>

<style lang="scss" scoped>
.cannotBeClicked {
    pointer-events: none;
}

.mainLine {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px dotted #ccc;
    padding: 0.1rem 0.3rem;
    cursor: pointer;

    .mainLineBox {
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .mainLineBlock {
            margin-right: 0.1rem;
            line-height: 0.25rem;
        }
    }

    &:nth-child(1) {
        border-top: 1px dotted #ccc;
    }
}
</style>